import React, { type FunctionComponent } from 'react'
import { ListItem } from '../../../../common/styled'
import { Status } from '../../../../common/styled/Status'
import { ArrowRightIcon } from '../../../../icons'
import { useNavigate } from 'react-router'
import { schemeMap } from '../../common/charity'

type Props = {
  campaign: CampaignSummaryType
}

export const CampaignListItem: FunctionComponent<Props> = ({ campaign }) => {
  const navigate = useNavigate()

  const { name, charitySummary, startTime, endTime, status } = campaign
  const { displayName, appContext } = charitySummary

  return (
    <ListItem
      onClick={() => navigate(`/charities/${charitySummary.id}`)}
      ariaLabel={`Show campaign ${name}`}
      label={
        <div className="flex">
          <div className="flex-1 flex flex-col items-start space-y-sm">
            <div className="tag inline-block">{schemeMap[appContext]}</div>
            <h2 className="pl-sm font-bold">{name}</h2>
            <div className="pl-sm text-sm">{displayName}</div>
            <div className="pl-sm text-sm">
              {new Date(startTime).toLocaleDateString()} - {new Date(endTime).toLocaleDateString()}
            </div>
          </div>

          <div className="flex justify-end items-center space-x-md">
            <div className="text-right h-full flex flex-col items-end space-y-sm">
              <div className="inline-block mb-xs tag font-bold text-sm">Campaign</div>
              <Status status={status} />
            </div>

            <ArrowRightIcon width="1rem" height="1rem" />
          </div>
        </div>
      }
    />
  )
}
